import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=6bba7ad2&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=6bba7ad2&prod&lang=css"
import style1 from "./PersonalInfo.vue?vue&type=style&index=1&id=6bba7ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bba7ad2",
  null
  
)

export default component.exports